import { Link } from 'react-router'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'

export const IntegratedHealthNotes = () => (
  <section className="bg-base-50 py-16 sm:py-20">
    <div className="mx-auto max-w-5xl px-6">
      <Reveal>
        <div className="rounded-3xl border border-base-200 bg-white p-7 sm:p-10">
          <h2 className="mb-4 font-display text-2xl text-base-900 sm:text-3xl">Please note</h2>
          <div className="max-w-3xl space-y-4 text-base leading-7 text-base-600">
            <p>
              This service covers your consultation, Bio-Scan, reports, professional assessment,
              recommendations and follow-up report-feedback session.
            </p>
            <p>
              Herbal medicines, supplements and other therapeutic products are not included and are
              charged separately.
            </p>
            <p>
              For those wanting ongoing, structured support where herbal treatment is included as
              part of a longer programme, please see the{' '}
              <Link
                to={ROUTES.WORK_WITH_ME}
                className="font-medium text-green-700 underline underline-offset-4 hover:text-green-800"
              >
                3 Month Integrated Health Programme
              </Link>
              .
            </p>
            <p>
              The Bio-Scan component is a holistic health assessment and educational tool. It is not
              a diagnostic medical test and does not diagnose disease, confirm nutritional
              deficiencies or replace appropriate medical tests or investigations.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
)
